/**
 * Отображаемое имя: «Фамилия Имя»
 * @param {{ name?: string|null, last_name?: string|null }|null|undefined} user
 */
export function formatUserDisplayName(user) {
    if (!user) return '';
    const ln = (user.last_name || '').trim();
    const fn = (user.name || '').trim();
    if (!ln) return fn;
    if (!fn) return ln;
    const loweredFn = fn.toLowerCase();
    const loweredLn = ln.toLowerCase();
    if (loweredFn === loweredLn || loweredFn.startsWith(`${loweredLn} `)) {
        return fn;
    }
    return `${ln} ${fn}`;
}

const GROUP_ROLE_LABELS = {
    'тренер': 'Преподаватель',
    'треннер': 'Преподаватель',
    'приглашённый тренер': 'Приглашённый преподаватель',
    'приглашенный тренер': 'Приглашённый преподаватель'
};

/** Роль в группе: старые подписи «тренер» показываем как «преподаватель». */
export function displayGroupRole(role) {
    const raw = String(role || '').trim();
    if (!raw) return '';
    return GROUP_ROLE_LABELS[raw.toLowerCase()] || raw;
}

/**
 * Убрать повтор фамилии в начале: «Поташкова Поташкова Мария» → «Поташкова Мария»
 */
function collapseDuplicateLastName(fullName, lastName) {
    let result = (fullName || '').trim();
    const ln = (lastName || '').trim();
    if (!result || !ln) return result;

    const loweredLn = ln.toLowerCase();
    // Пока в начале два раза подряд фамилия — снимаем один префикс
    while (true) {
        const lowered = result.toLowerCase();
        const doublePrefix = `${loweredLn} ${loweredLn}`;
        if (lowered === doublePrefix || lowered.startsWith(`${doublePrefix} `)) {
            result = result.slice(ln.length).trim();
            continue;
        }
        break;
    }
    return result;
}

/**
 * Имя тренера из API расписания: поле name уже может быть «Фамилия Имя»,
 * при этом last_name дублирует фамилию — не склеиваем повторно.
 */
export function displayTrainerName(trainer) {
    if (!trainer) return '';
    const ln = (trainer.last_name || '').trim();
    const rawName = (trainer.name || '').trim();
    if (!rawName && !ln) return '';
    if (!rawName) return ln;

    const collapsed = collapseDuplicateLastName(rawName, ln);
    if (ln && collapsed) {
        const loweredName = collapsed.toLowerCase();
        const loweredLn = ln.toLowerCase();
        if (loweredName === loweredLn || loweredName.startsWith(`${loweredLn} `)) {
            return collapsed;
        }
    }
    return formatUserDisplayName({ name: collapsed, last_name: ln });
}
